/**
 * La versione dei Termini di servizio e dell'informativa sulla privacy in
 * vigore: la data dell'ultima modifica fra le due pagine della landing.
 *
 * Quando cambiano, si aggiorna qui con la nuova data, e chi ha accettato la
 * versione precedente se li vede chiedere di nuovo al primo accesso.
 */
export const VERSIONE_TERMINI = "2026-10-07";
